import { render } from "./NormatividadPage.vue?vue&type=template&id=b842da66"
import script from "./NormatividadPage.vue?vue&type=script&lang=js"
export * from "./NormatividadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__